<template>
  <div>
    <x-box
      :title="$t('string.whyUsSectionImage')"
      tool
    >
      <template slot="box-tools">
        <button
          v-if="can([$Permissions.backend.setting.whyUsImage.store])"
          class="btn btn-primary btn-sm"
          data-toggle="modal"
          ref="modal"
          data-target="#myModal"
        >
          <i class="fa fa-plus" /> {{ $t('string.add') }}
        </button>
      </template>
      <table
        id="why-us-image-table"
        class="table table-hover table-striped table-bordered"
      >
        <tbody />
      </table>
    </x-box>
    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              @click="onResetForm"
              ref="close"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
              >&times;</span>
            </button>
            <h4
              class="modal-title"
              id="myModalLabel"
            >
              {{ $t('string.whyUsImage') }}
            </h4>
          </div>
          <div class="modal-body">
            <template v-if="isLoading">
              {{ $t('string.isLoading') }}
            </template>
            <template v-else>
              <x-input
                :label="$t('fields.khmerName')"
                :placeholder="$t('fields.khmerName')"
                v-model="whyUsImage.title_km"
                :required="true"
                name="title_km"
                :validations="validations"
              />

              <x-input
                :label="$t('fields.englishName')"
                :placeholder="$t('fields.englishName')"
                v-model="whyUsImage.title_en"
                :required="true"
                name="title_en"
                :validations="validations"
              />

              <div
                class="form-group"
                :class="{'has-error' : validations['image']}"
              >
                <label for="image">
                  {{ $t('fields.image') }}
                  <tooltip-info>
                    <p>Background image size: </p>
                    <ul style="margin: 15px;padding: 0;">
                      <li>Dimension 570x495 Pixels</li>
                      <li>Aspect ratio 1:1</li>
                    </ul>
                  </tooltip-info>
                </label>
                <input
                  type="file"
                  id="image"
                  ref="image"
                  accept="image/jpeg,image/png,image/jpg"
                  class="custom-file-input"
                  @change="previewFiles"
                >
                <div>
                  <label
                    for="image"
                    class="btn btn-primary btn-sm"
                  >
                    <i class="fa fa-image" /> {{ $t('string.chooseAnImage') }}
                  </label>
                </div>
                <template v-if="validations['image']">
                  <span class="label-error">{{ validations['image'][0] }}</span>
                </template>
              </div>
              <div class="form-group">
                <img
                  v-if="preview"
                  :src="preview"
                  class="preview-img"
                >
              </div>
              <div class="form-group">
                <label for="active">
                  <input
                    type="checkbox"
                    id="active"
                    :value="true"
                    v-model="whyUsImage.active"
                  >
                  {{ $t('fields.active') }}
                </label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="onResetForm"
              class="btn btn-default"
              data-dismiss="modal"
            >
              {{ $t('button.close') }}
            </button>
            <button
              @click="onSave"
              type="button"
              class="btn btn-primary"
            >
              {{ $t('button.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipInfo from '@/components/TooltipInfo'

export default {
  name: 'ImageWhyUsList',
  components: { TooltipInfo },
  data () {
    return {
      oTable: null,
      validations: {},
      whyUsImage: {
        title_en: '',
        title_km: '',
        active: true
      },
      preview: process.env.VUE_APP_API + '/img/default.png',
      isLoading: false
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
      this.loadAction()
    }
  },
  methods: {
    onResetForm () {
      this.$refs.close.click()
      this.whyUsImage = {
        title_en: '',
        title_km: '',
        active: true
      }
      this.validations = {}
      this.isLoading = false
    },
    onSave () {
      const params = new FormData()
      Object.keys(this.whyUsImage).forEach((key) => {
        const value = this.whyUsImage[key]
        if (value) {
          params.set(key, value)
        } else {
          params.delete(key)
        }
      })

      if (this.$refs.image.files.length) {
        params.set('image', this.$refs.image.files[0])
      } else {
        params.delete('image')
      }

      let url = '/api/v4/backend/why-us-image/create'
      if (this.whyUsImage.why_us_image_uuid) {
        url = '/api/v4/backend/why-us-image/update'
      }

      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + url, params)
        .then(({ data }) => {
          if (data.data) {
            this.oTable.draw()
            this.$toastr('success', 'The request was processed', 'Why Us Image')
            this.onResetForm()
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    getWhyUsImage (uuid) {
      this.isLoading = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/why-us-image/show', {
        why_us_image_uuid: uuid
      }).then(({ data }) => {
        if (data.data) {
          const whyUsImage = data.data
          this.whyUsImage = {
            why_us_image_uuid: whyUsImage.uuid,
            title_en: whyUsImage.title_en,
            title_km: whyUsImage.title_km,
            active: whyUsImage.active
          }
          if (whyUsImage.image) {
            this.preview = `${process.env.VUE_APP_API}/${whyUsImage.image}`
          }
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isLoading = false
      })
    },
    previewFiles (e) {
      this.whyUsImage.icon = e.target.files[0]
      this.preview = URL.createObjectURL(this.whyUsImage.icon)
    },
    deleteWhyUsImage (uuid) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/why-us-image/delete', {
            why_us_image_uuid: uuid
          }).then((response) => {
            if (response.data.code === 1) {
              this.oTable.draw(true)
            }
            this.$swal(
              self.$t('string.deleted!'),
              self.$t('string.theRequestHaveBeenProcessed'),
              'success'
            )
          })
        }
      })
    },
    toggleWhyUsImage (uuid) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesToggleIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/why-us-image/toggle', {
            why_us_image_uuid: uuid
          }).then((response) => {
            if (response.data.code === 1) {
              this.oTable.draw(true)
              this.$swal(
                self.$t('string.toggled!'),
                self.$t('string.theRequestHaveBeenProcessed'),
                'success'
              )
            }
          })
        }
      })
    },
    refreshTable () {
      return $('#why-us-image-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v4/backend/why-us-image/datatable',
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            title: this.$t('table.action'),
            render: (data, type, row) => {
              let action = ''
              if (this.can([this.$Permissions.backend.setting.whyUsImage.edit])) {
                action += `
                  <button class="btn btn-primary btn-xs btn-why-us-edit"
                      data-toggle="tooltip"
                      title="${this.$t('label.edit')}"
                      data-uuid="${row.uuid}">
                    <i class="fa fa-edit"></i>
                  </button> `
              }
              if (this.can([this.$Permissions.backend.setting.whyUsImage.toggle])) {
                action += `
                   <button class="btn btn-info btn-xs btn-why-us-toggle"
                        data-toggle="tooltip"
                        title="${this.$t('label.toggle')}"
                        data-uuid="${row.uuid}">
                     <i class="fa fa-refresh"></i>
                   </button> `
              }
              if (this.can([this.$Permissions.backend.setting.whyUsImage.delete])) {
                action += `<button class="btn btn-danger btn-xs btn-why-us-delete"
                        data-toggle="tooltip"
                        title="${this.$t('label.delete')}"
                        data-uuid="${row.uuid}">
                     <i class="fa fa-trash"></i>
                   </button>`
              }
              if (action !== '') {
                return action
              }
              return this.$t('string.noPermission')
            }
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            title: this.$t('table.createdAt')
          },
          {
            data: 'active',
            name: 'active',
            title: this.$t('table.status'),
            searchable: false,
            render: (data, type, row) => {
              if (row.active) {
                return `<label class="label label-primary">${this.$t('string.active')}</label>`
              } else {
                return `<label class="label label-default">${this.$t('string.inactive')}</label>`
              }
            }
          },
          {
            data: 'image',
            name: 'image',
            title: this.$t('table.image'),
            render: (data, type, row) => {
              if (row.image !== null) {
                return `<img src='${process.env.VUE_APP_API}/${row.image}' width="40px" height="40px"/>`
              } else {
                return this.$t('string.na')
              }
            }
          },
          { data: 'title_en', name: 'title_en', title: this.$t('table.titleEn') },
          { data: 'title_km', name: 'title_km', title: this.$t('table.titleKm') }
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        order: [
          [1, 'desc']
        ]
      })
    },
    loadAction () {
      this.clearEventHandlers([
        '.btn-why-us-edit',
        '.btn-why-us-toggle',
        '.btn-why-us-delete'
      ])
      const self = this
      $(document).on('click', '.btn-why-us-edit', function () {
        self.getWhyUsImage($(this).attr('data-uuid'))
        self.$refs.modal.click()
      })
      $(document).on('click', '.btn-why-us-delete', function () {
        self.deleteWhyUsImage($(this).attr('data-uuid'))
      })
      $(document).on('click', '.btn-why-us-toggle', function () {
        self.toggleWhyUsImage($(this).attr('data-uuid'))
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.loadAction()
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>
.preview-img {
  width: 25%;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}

[type="file"] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}

[type="file"] + label {
  background-color: #3b569f;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  padding: 5px 10px;
}

[type="file"]:focus + label,
[type="file"] + label:hover {
  background-color: #2c4077;
}

[type="file"]:focus + label {
  outline: 1px dotted #000;
}

@media screen and (max-width: 992px) {
  .preview-img {
    width: 45%;
  }
}

@media screen and (max-width: 768px) {
  .preview-img {
    width: 35%;
  }
}

@media screen and (max-width: 576px) {
  .preview-img {
    width: 40%;
  }
}
</style>
